export const INTEGRATIONS_STATE = 'apps.settings.integrations';
export const INTEGRATIONS_LIST_STATE = 'apps.settings.integrations.list';
export const INTEGRATIONS_OPEN_STATE = 'apps.settings.integrations.open';
export const INTEGRATIONS_ALERTS_STATE = 'apps.settings.integrations.alerts';
export const CAP_ALERTS_INTEGRATION_ID = 'cap-alerts';

const INTEGRATION_ID_PATTERN = /^[a-z0-9-]+$/i;

export function isCompanyIntegrationId(value: unknown): value is string {
  return typeof value === 'string' && INTEGRATION_ID_PATTERN.test(value);
}

export function companyIntegrationOpenTarget(integrationId: string): {
  state: string;
  params: { integrationId: string };
} {
  return {
    state: INTEGRATIONS_OPEN_STATE,
    params: { integrationId },
  };
}

export function companyIntegrationIdFromRouter(
  stateName: string | undefined,
  params: { integrationId?: unknown },
): string | null {
  if (
    stateName === INTEGRATIONS_OPEN_STATE &&
    isCompanyIntegrationId(params.integrationId)
  ) {
    return params.integrationId;
  }

  return null;
}
